module.exports = __webpack_public_path__ + "static/5-82926fdd865d327dad3163f85d51bf8b.jpg";